import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=73c25fc7&scoped=true"
import script from "./SystemError.vue?vue&type=script&lang=js"
export * from "./SystemError.vue?vue&type=script&lang=js"
import style0 from "./SystemError.vue?vue&type=style&index=0&id=73c25fc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c25fc7",
  null
  
)

export default component.exports